// extracted by mini-css-extract-plugin
export var overlayFooterActionButtons = "mXOLZoiZiRs6kKmK2olC";
export var overlayFooterContent = "_zh9F8VN019h8cvXd9qp";
export var overlayFooterShadow = "MfBwl7gLhQy1SpzcnsZJ";
export var root = "vEwRFSIXJSGlPNxo7t3Y";